/**
 * Avalna Mobile Shell — Batch 03a
 * Overlay open/close, focus trap, body scroll lock,
 * service worker registration, cart badge updates.
 */

(function AvalnaShell() {
  'use strict';

  /* ---------- DOM REFERENCES ---------- */

  const avalnaBottomNav = document.getElementById('avalna-bottom-nav');
  if (!avalnaBottomNav) return; // bail on desktop if markup absent

  const avalnaHomeBtn = document.getElementById('avalna-tab-home');
  const avalnaShopBtn = document.getElementById('avalna-tab-shop');
  const avalnaSearchBtn = document.getElementById('avalna-tab-search');
  const avalnaCartBtn = document.getElementById('avalna-tab-cart');
  const avalnaMoreBtn = document.getElementById('avalna-tab-more');

  const avalnaMoreOverlay = document.getElementById('avalna-overlay-more');
  const avalnaMoreCloseBtn = document.getElementById('avalna-overlay-more-close');
  const avalnaCartBadge = document.getElementById('avalna-cart-badge');

  /* ---------- STATE ---------- */

  let avalnaOverlayOpen = false;
  let avalnaScrollY = 0;
  let avalnaSwipeStartX = 0;

  /* ---------- SCROLL LOCK ---------- */

  function avalnaLockScroll() {
    avalnaScrollY = window.scrollY;
    document.body.style.top = `-${avalnaScrollY}px`;
    document.body.classList.add('avalna-scroll-locked');
  }

  function avalnaUnlockScroll() {
    document.body.classList.remove('avalna-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, avalnaScrollY);
  }

  /* ---------- FOCUS TRAP ---------- */

  const AVALNA_FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea';

  function avalnaCreateFocusTrap(overlayEl) {
    const focusable = overlayEl.querySelectorAll(AVALNA_FOCUSABLE);
    if (!focusable.length) return null;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function avalnaTrapHandler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    overlayEl.addEventListener('keydown', avalnaTrapHandler);
    if (avalnaMoreCloseBtn) {
      avalnaMoreCloseBtn.focus();
    } else {
      first.focus();
    }
    return function avalnaRemoveTrap() {
      overlayEl.removeEventListener('keydown', avalnaTrapHandler);
    };
  }

  let avalnaRemoveFocusTrap = null;

  /* ---------- OVERLAY OPEN / CLOSE ---------- */

  function avalnaOpenOverlay() {
    if (avalnaOverlayOpen) return;
    avalnaLockScroll();
    avalnaMoreOverlay.classList.add('avalna-overlay--open');
    avalnaMoreOverlay.setAttribute('aria-hidden', 'false');
    avalnaOverlayOpen = true;
    avalnaRemoveFocusTrap = avalnaCreateFocusTrap(avalnaMoreOverlay);
    avalnaMoreBtn.classList.add('avalna-bottom-nav__tab--active');
    
    // push state for back button
    history.pushState({ avalnaOverlayOpen: true }, '');
  }

  function avalnaCloseOverlay(fromPopState = false) {
    if (!avalnaOverlayOpen) return;
    avalnaMoreOverlay.classList.remove('avalna-overlay--open');
    avalnaMoreOverlay.classList.add('avalna-overlay--closing');
    
    setTimeout(() => {
      avalnaMoreOverlay.classList.remove('avalna-overlay--closing');
      avalnaMoreOverlay.setAttribute('aria-hidden', 'true');
    }, 200);

    avalnaUnlockScroll();
    if (avalnaRemoveFocusTrap) {
      avalnaRemoveFocusTrap();
      avalnaRemoveFocusTrap = null;
    }
    avalnaOverlayOpen = false;
    avalnaMoreBtn.classList.remove('avalna-bottom-nav__tab--active');
    
    if (!fromPopState) {
      if (history.state && history.state.avalnaOverlayOpen) {
        history.back();
      }
    }
  }

  /* ---------- TAB HANDLERS ---------- */

  if (avalnaHomeBtn) {
    avalnaHomeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/';
    });
  }

  if (avalnaShopBtn) {
    avalnaShopBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/collections';
    });
  }

  if (avalnaMoreBtn && avalnaMoreOverlay) {
    avalnaMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (avalnaOverlayOpen) {
        avalnaCloseOverlay();
      } else {
        avalnaOpenOverlay();
      }
    });

    if (avalnaMoreCloseBtn) {
      avalnaMoreCloseBtn.addEventListener('click', () => avalnaCloseOverlay());
    }
  }

  // Cart tab — open cart drawer or navigate
  if (avalnaCartBtn) {
    avalnaCartBtn.addEventListener('click', function avalnaCartClick(e) {
      e.preventDefault();
      if (avalnaOverlayOpen) avalnaCloseOverlay();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        // Dawn's cart-drawer custom element (cart-drawer.js) defines open()
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: try details toggle for older Dawn versions
          var cartDrawerDetails = cartDrawer.querySelector('details');
          if (cartDrawerDetails) {
            cartDrawerDetails.setAttribute('open', '');
          }
        }
      } else {
        window.location.href = '/cart';
      }
    });
  }

  /* ---------- ESCAPE KEY & HISTORY BACK ---------- */

  document.addEventListener('keydown', function avalnaEscapeHandler(e) {
    if (e.key === 'Escape' && avalnaOverlayOpen) {
      avalnaCloseOverlay();
    }
  });

  window.addEventListener('popstate', function (e) {
    if (avalnaOverlayOpen) {
      avalnaCloseOverlay(true);
    }
  });

  /* ---------- SWIPE TO DISMISS ---------- */

  function avalnaSetupSwipeDismiss(overlayEl) {
    overlayEl.addEventListener('touchstart', function avalnaSwipeStart(e) {
      avalnaSwipeStartX = e.touches[0].clientX;
    }, { passive: true });

    overlayEl.addEventListener('touchend', function avalnaSwipeEnd(e) {
      const endX = e.changedTouches[0].clientX;
      const diff = endX - avalnaSwipeStartX;
      if (diff > 100) {
        avalnaCloseOverlay();
      }
    }, { passive: true });
  }

  if (avalnaMoreOverlay) avalnaSetupSwipeDismiss(avalnaMoreOverlay);

  /* ---------- CART BADGE ---------- */

  function avalnaUpdateCartBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (avalnaCartBadge) {
          avalnaCartBadge.textContent = data.item_count > 0 ? data.item_count : '';
        }
      })
      .catch(function () { /* silently fail */ });
  }

  avalnaUpdateCartBadge();

  document.addEventListener('cart:updated', avalnaUpdateCartBadge);
  const avalnaDawnCartBubble = document.getElementById('cart-icon-bubble');
  if (avalnaDawnCartBubble) {
    const avalnaCartObserver = new MutationObserver(avalnaUpdateCartBadge);
    avalnaCartObserver.observe(avalnaDawnCartBubble, { childList: true, subtree: true });
  }

  /* ---------- ACTIVE TAB HIGHLIGHT ---------- */

  function avalnaHighlightActiveTab() {
    const path = window.location.pathname;
    const tabs = avalnaBottomNav.querySelectorAll('.avalna-bottom-nav__tab');
    tabs.forEach(function avalnaResetTab(tab) {
      tab.removeAttribute('aria-current');
      tab.classList.remove('avalna-bottom-nav__tab--active');
    });

    // on PDP NO tab is active
    if (path.startsWith('/products/')) {
      return;
    }

    if (path === '/') {
      if (avalnaHomeBtn) avalnaHomeBtn.setAttribute('aria-current', 'page');
    } else if (path.startsWith('/search')) {
      if (avalnaSearchBtn) avalnaSearchBtn.setAttribute('aria-current', 'page');
    } else if (path === '/cart') {
      if (avalnaCartBtn) avalnaCartBtn.setAttribute('aria-current', 'page');
    } else if (path.startsWith('/collections')) {
      if (avalnaShopBtn) avalnaShopBtn.classList.add('avalna-bottom-nav__tab--active');
    }
  }

  avalnaHighlightActiveTab();

  /* ---------- SERVICE WORKER REGISTRATION — REMOVED, BATCH 38C ----------
   * Registration has never succeeded. Shopify serves theme assets from the CDN asset directory, which caps
   * a worker's scope to that directory, and the Service-Worker-Allowed header cannot be set there. The call
   * requested scope '/cdn/' for a worker at '/cdn/shop/t/30/assets/' and the browser rejected it on every
   * page load since Batch 03. The rejection was caught, so it never reached window.onerror — it was console
   * noise, not one of the Clarity errors (Gotcha #52 said otherwise and was wrong).
   *
   * assets/avalna-service-worker.js is deliberately left in the theme, unreferenced, for one release.
   * Delete it in a later batch once this has shipped and nothing regressed.
   *
   * The PWA manifest, theme-color, apple-touch-icon and Android home-screen install do NOT need a worker
   * and are unaffected. Offline caching has never worked and must not be claimed anywhere.
   */

})();
